import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { distinctBy } from "../utils/distinct-by";
import { useScopes } from "./useScopes";

export const useAvailableTreatments = (controller: FlexSectionController) => {
	const { selectedScopes } = useScopes(controller.context);

	return distinctBy(
		selectedScopes.flatMap((scope) => scope.treatmentSets).flatMap((s) => s.treatments),
		(treatment) => treatment.Code
	);
};
